/* eslint-disable react/display-name */
export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 736">
        <defs>
            <style>{`
.s3_1{fill:url(#linear-gradient);}
.s3_2,
.s3_3,
.s3_4,
.s3_5{stroke-linejoin:round;}
.s3_2,
.s3_3,
.s3_4,
.s3_5,
.s3_6{fill:none;}
.s3_2,
.s3_4{stroke:#79f2c0;}
.s3_7{fill:#f99cdb;}
.s3_8,
.s3_9{fill:#e3fcef;}
.s3_10{fill:#ed50b4;}
.s3_11{fill:#ffe380;}
.s3_12,
.s3_13{fill:#fff;}
.s3_14{fill:#fff0b2;}
.s3_15{fill:#fff2fb;}
.s3_16{fill:#ffc400;}
.s3_17{fill:#fcc6eb;}
.s3_18{fill:#deebff;}
.s3_19{fill:#1ab9d4;}
.s3_20{fill:#37b4c3;}
.s3_21,
.s3_22{fill:#4c9aff;}
.s3_23,
.s3_24,
.s3_25,
.s3_26,
.s3_27{fill:#79f2c0;}
.s3_28{fill:url(#linear-gradient-6);}
.s3_28,
.s3_29,
.s3_30,
.s3_31,
.s3_32,
.s3_33,
.s3_34,
.s3_35,
.s3_3,
.s3_4,
.s3_5,
.s3_22,
.s3_24,
.s3_36,
.s3_37,
.s3_38{mix-blend-mode:multiply;}
.s3_29{fill:url(#linear-gradient-7);}
.s3_30{fill:url(#linear-gradient-5);}
.s3_31{fill:url(#linear-gradient-8);}
.s3_32{fill:url(#linear-gradient-9);}
.s3_33{fill:url(#linear-gradient-4);}
.s3_34{fill:url(#linear-gradient-2);}
.s3_35{fill:url(#linear-gradient-3);}
.s3_3{stroke:#b2d4ff;}
.s3_3,
.s3_4,
.s3_5,
.s3_22,
.s3_24,
.s3_39{opacity:.2;}
.s3_5,
.s3_6{stroke:#4c9aff;}
.s3_40{filter:url(#drop-shadow-7);}
.s3_41{filter:url(#drop-shadow-4);}
.s3_39{fill:#008da6;}
.s3_6{stroke-dasharray:0 0 6 6;stroke-miterlimit:10;stroke-width:2px;}
.s3_36{fill:url(#radial-gradient);}
.s3_42{opacity:.5;}
.s3_43{fill:#2684ff;filter:url(#drop-shadow-3);}
.s3_13{filter:url(#drop-shadow-9);}
.s3_9{filter:url(#drop-shadow-2);}
.s3_25{filter:url(#drop-shadow-10);}
.s3_26{filter:url(#drop-shadow-11);}
.s3_44{fill:url(#linear-gradient-12);}
.s3_45{isolation:isolate;}
.s3_27{fill-rule:evenodd;filter:url(#drop-shadow-8);}
.s3_37{fill:url(#linear-gradient-10);}
.s3_38{fill:url(#linear-gradient-11);}
`}</style>
            <radialGradient
                id="radial-gradient"
                cx="450"
                cy="368"
                fx="450"
                fy="368"
                r="510.15"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#b2d4ff" />
                <stop offset=".05" stopColor="#b6d6ff" stopOpacity=".95" />
                <stop offset=".15" stopColor="#c0dbff" stopOpacity=".83" />
                <stop offset=".28" stopColor="#d2e4ff" stopOpacity=".63" />
                <stop offset=".36" stopColor="#deebff" stopOpacity=".5" />
                <stop offset=".45" stopColor="#e0ecff" stopOpacity=".47" />
                <stop offset=".59" stopColor="#e6efff" stopOpacity=".38" />
                <stop offset=".77" stopColor="#eff5ff" stopOpacity=".23" />
                <stop offset=".98" stopColor="#fdfdff" stopOpacity=".03" />
                <stop offset="1" stopColor="#fff" stopOpacity="0" />
            </radialGradient>
            <filter id="drop-shadow-2" filterUnits="userSpaceOnUse">
                <feOffset dx="1" dy="1" />
                <feGaussianBlur result="blur" stdDeviation="1" />
                <feFlood floodColor="#0e1f40" floodOpacity=".15" />
                <feComposite in2="blur" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
            <linearGradient
                id="linear-gradient"
                x1="97.4"
                y1="662.28"
                x2="426.14"
                y2="463.05"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset=".25" stopColor="#4c9aff" />
                <stop offset="1" stopColor="#b2d4ff" />
            </linearGradient>
            <linearGradient
                id="linear-gradient-2"
                x1="410.62"
                y1="815.67"
                x2="571.5"
                y2="490.69"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#deebff" />
                <stop offset=".12" stopColor="#deebff" stopOpacity=".98" />
                <stop offset=".26" stopColor="#deebff" stopOpacity=".92" />
                <stop offset=".41" stopColor="#deebff" stopOpacity=".83" />
                <stop offset=".58" stopColor="#deebff" stopOpacity=".7" />
                <stop offset=".74" stopColor="#deebff" stopOpacity=".53" />
                <stop offset=".91" stopColor="#deebff" stopOpacity=".33" />
                <stop offset=".93" stopColor="#deebff" stopOpacity=".3" />
            </linearGradient>
            <linearGradient
                id="linear-gradient-3"
                x1="431.65"
                y1="826.08"
                x2="592.52"
                y2="501.1"
                xlinkHref="#linear-gradient-2"
            />
            <linearGradient
                id="linear-gradient-4"
                x1="442.53"
                y1="831.46"
                x2="603.4"
                y2="506.49"
                xlinkHref="#linear-gradient-2"
            />
            <linearGradient
                id="linear-gradient-5"
                x1="399.99"
                y1="810.4"
                x2="560.86"
                y2="485.43"
                xlinkHref="#linear-gradient-2"
            />
            <linearGradient
                id="linear-gradient-6"
                x1="421.26"
                y1="820.93"
                x2="582.13"
                y2="495.96"
                xlinkHref="#linear-gradient-2"
            />
            <linearGradient
                id="linear-gradient-7"
                x1="365.92"
                y1="793.54"
                x2="526.79"
                y2="468.56"
                xlinkHref="#linear-gradient-2"
            />
            <linearGradient
                id="linear-gradient-8"
                x1="376.55"
                y1="798.8"
                x2="537.43"
                y2="473.83"
                xlinkHref="#linear-gradient-2"
            />
            <linearGradient
                id="linear-gradient-9"
                x1="387.19"
                y1="804.06"
                x2="548.06"
                y2="479.09"
                xlinkHref="#linear-gradient-2"
            />
            <linearGradient
                id="linear-gradient-10"
                x1="397.82"
                y1="809.33"
                x2="558.7"
                y2="484.36"
                xlinkHref="#linear-gradient-2"
            />
            <linearGradient
                id="linear-gradient-11"
                x1="408.45"
                y1="814.59"
                x2="569.33"
                y2="489.62"
                xlinkHref="#linear-gradient-2"
            />
            <linearGradient
                id="linear-gradient-12"
                x1="108.55"
                y1="170.23"
                x2="322.84"
                y2="520.12"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#b2d4ff" />
                <stop offset=".44" stopColor="#4c9aff" />
                <stop offset=".79" stopColor="#0065ff" />
            </linearGradient>
            <filter id="drop-shadow-3" filterUnits="userSpaceOnUse">
                <feOffset dx="1" dy="1" />
                <feGaussianBlur result="blur-2" stdDeviation="1" />
                <feFlood floodColor="#0e1f40" floodOpacity=".15" />
                <feComposite in2="blur-2" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
            <filter id="drop-shadow-4" filterUnits="userSpaceOnUse">
                <feOffset dx="1" dy="1" />
                <feGaussianBlur result="blur-3" stdDeviation="1" />
                <feFlood floodColor="#0e1f40" floodOpacity=".15" />
                <feComposite in2="blur-3" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
            <filter id="drop-shadow-7" filterUnits="userSpaceOnUse">
                <feOffset dx="1" dy="1" />
                <feGaussianBlur result="blur-4" stdDeviation="1" />
                <feFlood floodColor="#0e1f40" floodOpacity=".15" />
                <feComposite in2="blur-4" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
            <filter id="drop-shadow-8" filterUnits="userSpaceOnUse">
                <feOffset dx="1.8" dy="1.8" />
                <feGaussianBlur result="blur-5" stdDeviation="1.2" />
                <feFlood floodColor="#0e1f40" floodOpacity=".3" />
                <feComposite in2="blur-5" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
            <filter id="drop-shadow-9" filterUnits="userSpaceOnUse">
                <feOffset dx="1.8" dy="1.8" />
                <feGaussianBlur result="blur-6" stdDeviation="1.2" />
                <feFlood floodColor="#0e1f40" floodOpacity=".3" />
                <feComposite in2="blur-6" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
            <filter id="drop-shadow-10" filterUnits="userSpaceOnUse">
                <feOffset dx="1.62" dy="1.62" />
                <feGaussianBlur result="blur-7" stdDeviation="1.08" />
                <feFlood floodColor="#0e1f40" floodOpacity=".3" />
                <feComposite in2="blur-7" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
            <filter id="drop-shadow-11" filterUnits="userSpaceOnUse">
                <feOffset dx="1.62" dy="1.62" />
                <feGaussianBlur result="blur-8" stdDeviation="1.08" />
                <feFlood floodColor="#0e1f40" floodOpacity=".3" />
                <feComposite in2="blur-8" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
        </defs>
        <g className="s3_45">
            <g id="bg">
                <path
                    className="s3_36"
                    d="m900,67.28v-1h-68.73V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73Zm-138.96,0v65.78h-68.23v-65.78h68.23Zm-345.16,267.13h68.23v65.78h-68.23v-65.78Zm-1,65.78h-68.23v-65.78h68.23v65.78Zm70.23-65.78h68.23v65.78h-68.23v-65.78Zm0-1v-65.78h68.23v65.78h-68.23Zm-1,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm0,1v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm1,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm0-1v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm-1,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm0,1v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm1,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm0-1v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm-1,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm0,1v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm1,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm0-1v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm-1-132.56v65.78h-68.23v-65.78h68.23Zm-69.23,0v65.78h-68.23v-65.78h68.23Zm-69.23,0v65.78h-68.23v-65.78h68.23Zm-69.23,0v65.78h-68.23v-65.78h68.23Zm-69.23,0v65.78h-68.23v-65.78h68.23Zm-69.23,0v65.78h-68.23v-65.78h68.23Zm-69.23,0v65.78h-68.23v-65.78h68.23Zm-69.23,0v65.78h-68.23v-65.78h68.23Zm-137.46,0h68.23v65.78h-68.23v-65.78Zm0,66.78h68.23v65.78h-68.23v-65.78Zm0,66.78h68.23v65.78h-68.23v-65.78Zm0,66.78h68.23v65.78h-68.23v-65.78Zm0,66.78h68.23v65.78h-68.23v-65.78Zm0,66.78h68.23v65.78h-68.23v-65.78Zm0,66.78h68.23v65.78h-68.23v-65.78Zm0,66.78h68.23v65.78h-68.23v-65.78Zm0,132.56v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm137.46,0h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Z"
                />
            </g>
            <g id="illos">
                <path
                    className="s3_6"
                    d="m428.02,537.44c-32.07-.52-62.19-9.06-88.44-23.69-52.09-29.03-86.75-81.66-94.27-140.81l-2.76-21.69"
                />
                <g>
                    <g>
                        <rect
                            className="s3_18"
                            x="325.83"
                            y="385.34"
                            width="340.93"
                            height="253.57"
                            rx="2"
                            ry="2"
                        />
                        <path
                            className="s3_6"
                            d="m578.35,465.89c25.59-32.06,41.03-72.5,41.15-116.26.02-8.79-.55-17.44-1.7-25.91"
                        />
                        <rect
                            className="s3_9"
                            x="382.42"
                            y="456.29"
                            width="250.79"
                            height="27.34"
                        />
                        <g id="topnav">
                            <rect
                                className="s3_1"
                                x="325.83"
                                y="385.34"
                                width="38.66"
                                height="253.57"
                            />
                        </g>
                        <g>
                            <g className="s3_42">
                                <path
                                    className="s3_18"
                                    d="m347.52,413.56h-4.71c-.41,0-.8-.16-1.08-.45-.29-.29-.45-.68-.45-1.08v-4.6c0-.41.16-.8.45-1.08.29-.29.68-.45,1.08-.45h4.71c.41,0,.8.16,1.08.45.29.29.45.68.45,1.08v4.6c0,.41-.16.8-.45,1.08-.29.29-.68.45-1.08.45Z"
                                />
                            </g>
                            <g className="s3_42">
                                <path
                                    className="s3_18"
                                    d="m347.52,434.15h-4.71c-.41,0-.8-.16-1.08-.45-.29-.29-.45-.68-.45-1.08v-4.6c0-.41.16-.8.45-1.08.29-.29.68-.45,1.08-.45h4.71c.41,0,.8.16,1.08.45.29.29.45.68.45,1.08v4.6c0,.41-.16.8-.45,1.08-.29.29-.68.45-1.08.45Z"
                                />
                            </g>
                            <g className="s3_42">
                                <path
                                    className="s3_18"
                                    d="m347.52,454.84h-4.71c-.41,0-.8-.16-1.08-.45-.29-.29-.45-.68-.45-1.08v-4.6c0-.41.16-.8.45-1.08.29-.29.68-.45,1.08-.45h4.71c.41,0,.8.16,1.08.45.29.29.45.68.45,1.08v4.6c0,.41-.16.8-.45,1.08-.29.29-.68.45-1.08.45Z"
                                />
                            </g>
                            <g className="s3_42">
                                <path
                                    className="s3_18"
                                    d="m347.52,475.48h-4.71c-.41,0-.8-.16-1.08-.45-.29-.29-.45-.68-.45-1.08v-4.6c0-.41.16-.8.45-1.08.29-.29.68-.45,1.08-.45h4.71c.41,0,.8.16,1.08.45.29.29.45.68.45,1.08v4.6c0,.41-.16.8-.45,1.08-.29.29-.68.45-1.08.45Z"
                                />
                            </g>
                            <g className="s3_42">
                                <path
                                    className="s3_18"
                                    d="m347.52,496.12h-4.71c-.41,0-.8-.16-1.08-.45-.29-.29-.45-.68-.45-1.08v-4.6c0-.41.16-.8.45-1.08.29-.29.68-.45,1.08-.45h4.71c.41,0,.8.16,1.08.45.29.29.45.68.45,1.08v4.6c0,.41-.16.8-.45,1.08-.29.29-.68.45-1.08.45Z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <circle
                            className="s3_23"
                            cx="550.33"
                            cy="470.21"
                            r="6.32"
                        />
                        <path
                            className="s3_8"
                            d="m551.88,467.94c-.77-.55-1.82-.64-2.67-.24-1.69.8-2.07,2.88-.96,4.21.1.12.21.23.33.33.32.27.51.67.51,1.09,0,.58-.35,1.1-.88,1.31-.5.21-.97.49-1.39.83,1.01.67,2.21,1.07,3.51,1.07s2.51-.39,3.51-1.07c-.42-.34-.88-.61-1.38-.82-.54-.22-.89-.74-.89-1.32,0-.42.18-.81.49-1.08,1.33-1.11,1.33-3.22-.19-4.31Z"
                        />
                    </g>
                    <g>
                        <circle
                            className="s3_34"
                            cx="550.33"
                            cy="533.45"
                            r="6.32"
                        />
                        <path
                            className="s3_18"
                            d="m551.88,531.17c-.77-.55-1.82-.64-2.67-.24-1.69.8-2.07,2.88-.96,4.21.1.12.21.23.33.33.32.27.51.67.51,1.09,0,.58-.35,1.1-.88,1.31-.5.21-.97.49-1.39.83,1.01.67,2.21,1.07,3.51,1.07s2.51-.39,3.51-1.07c-.42-.34-.88-.61-1.38-.82-.54-.22-.89-.74-.89-1.32,0-.42.18-.81.49-1.08,1.33-1.11,1.33-3.22-.19-4.31Z"
                        />
                    </g>
                    <g>
                        <circle
                            className="s3_35"
                            cx="550.33"
                            cy="586.33"
                            r="6.32"
                        />
                        <path
                            className="s3_18"
                            d="m551.88,584.06c-.77-.55-1.82-.64-2.67-.24-1.69.8-2.07,2.88-.96,4.21.1.12.21.23.33.33.32.27.51.67.51,1.09,0,.58-.35,1.1-.88,1.31-.5.21-.97.49-1.39.83,1.01.67,2.21,1.07,3.51,1.07s2.51-.39,3.51-1.07c-.42-.34-.88-.61-1.38-.82-.54-.22-.89-.74-.89-1.32,0-.42.18-.81.49-1.08,1.33-1.11,1.33-3.22-.19-4.31Z"
                        />
                    </g>
                    <g>
                        <circle
                            className="s3_33"
                            cx="550.33"
                            cy="613.69"
                            r="6.32"
                        />
                        <path
                            className="s3_18"
                            d="m551.88,611.41c-.77-.55-1.82-.64-2.67-.24-1.69.8-2.07,2.88-.96,4.21.1.12.21.23.33.33.32.27.51.67.51,1.09,0,.58-.35,1.1-.88,1.31-.5.21-.97.49-1.39.83,1.01.67,2.21,1.07,3.51,1.07s2.51-.39,3.51-1.07c-.42-.34-.88-.61-1.38-.82-.54-.22-.89-.74-.89-1.32,0-.42.18-.81.49-1.08,1.33-1.11,1.33-3.22-.19-4.31Z"
                        />
                    </g>
                    <g>
                        <circle
                            className="s3_30"
                            cx="550.33"
                            cy="506.7"
                            r="6.32"
                        />
                        <path
                            className="s3_18"
                            d="m553.28,510.03c.19-.1.27-.33.19-.53-.15-.37-.29-.75-.29-1.15v-2.09c0-.29-.05-.58-.13-.85-.02-.07-.04-.15-.06-.22,0,0,0-.01,0-.02-.23-.66-.67-1.26-1.5-1.63-.77-.34-1.68-.35-2.42.04-.81.42-1.29,1.13-1.46,1.9-.07.25-.11.51-.11.78v2.09c0,.4-.12.77-.28,1.13-.02.05-.04.11-.04.17,0,.23.19.42.42.43h1.27c-.16.29-.41.52-.73.65-.59.24-1.13.59-1.61,1.01.38.29.8.54,1.24.74l.17.08c.74.3,1.55.48,2.4.48s1.67-.17,2.42-.48l.14-.06c.45-.2.87-.45,1.26-.75-.48-.42-1.02-.76-1.6-1-.32-.13-.57-.36-.73-.65h1.26c.07,0,.14-.02.2-.05Z"
                        />
                    </g>
                    <g>
                        <circle
                            className="s3_28"
                            cx="550.33"
                            cy="560.19"
                            r="6.32"
                        />
                        <path
                            className="s3_18"
                            d="m553.28,563.53c.19-.1.27-.33.19-.53-.15-.37-.29-.75-.29-1.15v-2.09c0-.29-.05-.58-.13-.85-.02-.07-.04-.15-.06-.22,0,0,0-.01,0-.02-.23-.66-.67-1.26-1.5-1.63-.77-.34-1.68-.35-2.42.04-.81.42-1.29,1.13-1.46,1.9-.07.25-.11.51-.11.78v2.09c0,.4-.12.77-.28,1.13-.02.05-.04.11-.04.17,0,.23.19.42.42.43h1.27c-.16.29-.41.52-.73.65-.59.24-1.13.59-1.61,1.01.38.29.8.54,1.24.74l.17.08c.74.3,1.55.48,2.4.48s1.67-.17,2.42-.48l.14-.06c.45-.2.87-.45,1.26-.75-.48-.42-1.02-.76-1.6-1-.32-.13-.57-.36-.73-.65h1.26c.07,0,.14-.02.2-.05Z"
                        />
                    </g>
                    <line
                        className="s3_2"
                        x1="562.71"
                        y1="470.66"
                        x2="598.56"
                        y2="470.66"
                    />
                    <line
                        className="s3_2"
                        x1="393.38"
                        y1="470.66"
                        x2="472.28"
                        y2="470.66"
                    />
                    <line
                        className="s3_3"
                        x1="393.38"
                        y1="409.73"
                        x2="472.28"
                        y2="409.73"
                    />
                    <line
                        className="s3_3"
                        x1="393.38"
                        y1="420.1"
                        x2="472.28"
                        y2="420.1"
                    />
                    <line
                        className="s3_3"
                        x1="393.38"
                        y1="430.47"
                        x2="443.06"
                        y2="430.47"
                    />
                    <line
                        className="s3_3"
                        x1="562.71"
                        y1="506.7"
                        x2="598.56"
                        y2="506.7"
                    />
                    <line
                        className="s3_3"
                        x1="562.71"
                        y1="533.45"
                        x2="598.56"
                        y2="533.45"
                    />
                    <line
                        className="s3_3"
                        x1="562.71"
                        y1="560.19"
                        x2="598.56"
                        y2="560.19"
                    />
                    <line
                        className="s3_3"
                        x1="562.71"
                        y1="586.94"
                        x2="598.56"
                        y2="586.94"
                    />
                    <line
                        className="s3_3"
                        x1="562.71"
                        y1="613.69"
                        x2="598.56"
                        y2="613.69"
                    />
                    <rect
                        className="s3_23"
                        x="489.07"
                        y="465.89"
                        width="37.69"
                        height="9.53"
                        rx="1"
                        ry="1"
                    />
                    <line
                        className="s3_3"
                        x1="393.38"
                        y1="506.7"
                        x2="472.28"
                        y2="506.7"
                    />
                    <rect
                        className="s3_29"
                        x="489.07"
                        y="501.94"
                        width="37.69"
                        height="9.53"
                        rx="1"
                        ry="1"
                    />
                    <line
                        className="s3_3"
                        x1="393.38"
                        y1="533.45"
                        x2="472.28"
                        y2="533.45"
                    />
                    <rect
                        className="s3_31"
                        x="489.07"
                        y="528.68"
                        width="37.69"
                        height="9.53"
                        rx="1"
                        ry="1"
                    />
                    <line
                        className="s3_3"
                        x1="393.38"
                        y1="560.19"
                        x2="472.28"
                        y2="560.19"
                    />
                    <rect
                        className="s3_32"
                        x="489.07"
                        y="555.43"
                        width="37.69"
                        height="9.53"
                        rx="1"
                        ry="1"
                    />
                    <line
                        className="s3_3"
                        x1="393.38"
                        y1="586.94"
                        x2="472.28"
                        y2="586.94"
                    />
                    <rect
                        className="s3_37"
                        x="489.07"
                        y="582.18"
                        width="37.69"
                        height="9.53"
                        rx="1"
                        ry="1"
                    />
                    <line
                        className="s3_3"
                        x1="393.38"
                        y1="613.69"
                        x2="472.28"
                        y2="613.69"
                    />
                    <rect
                        className="s3_38"
                        x="489.07"
                        y="608.92"
                        width="37.69"
                        height="9.53"
                        rx="1"
                        ry="1"
                    />
                </g>
                <rect
                    className="s3_18"
                    x="459.14"
                    y="104.24"
                    width="295.35"
                    height="220.15"
                    rx="2"
                    ry="2"
                />
                <g>
                    <g>
                        <g>
                            <line
                                className="s3_5"
                                x1="672.37"
                                y1="121.93"
                                x2="730.63"
                                y2="121.93"
                            />
                            <line
                                className="s3_5"
                                x1="672.37"
                                y1="130.62"
                                x2="730.63"
                                y2="130.62"
                            />
                            <line
                                className="s3_5"
                                x1="672.37"
                                y1="139.31"
                                x2="730.63"
                                y2="139.31"
                            />
                            <line
                                className="s3_5"
                                x1="672.37"
                                y1="148"
                                x2="709.3"
                                y2="148"
                            />
                        </g>
                        <line
                            className="s3_5"
                            x1="643.88"
                            y1="159.96"
                            x2="664.23"
                            y2="129.14"
                        />
                    </g>
                    <g>
                        <g>
                            <line
                                className="s3_5"
                                x1="544.18"
                                y1="128.53"
                                x2="496.3"
                                y2="128.53"
                            />
                            <line
                                className="s3_5"
                                x1="523.05"
                                y1="137.22"
                                x2="496.3"
                                y2="137.22"
                            />
                        </g>
                        <line
                            className="s3_5"
                            x1="575.8"
                            y1="165.12"
                            x2="552.32"
                            y2="135.74"
                        />
                    </g>
                    <g>
                        <g>
                            <line
                                className="s3_5"
                                x1="702.28"
                                y1="297.35"
                                x2="654.4"
                                y2="297.35"
                            />
                            <line
                                className="s3_5"
                                x1="681.15"
                                y1="306.04"
                                x2="654.4"
                                y2="306.04"
                            />
                        </g>
                        <line
                            className="s3_5"
                            x1="620.13"
                            y1="276.93"
                            x2="646.26"
                            y2="298.82"
                        />
                    </g>
                </g>
                <rect
                    className="s3_44"
                    x="125.89"
                    y="208.54"
                    width="131.21"
                    height="194.25"
                    rx="2"
                    ry="2"
                />
                <g>
                    <g>
                        <rect
                            className="s3_12"
                            x="139.45"
                            y="236.18"
                            width="102.42"
                            height="37.13"
                            rx="2"
                            ry="2"
                        />
                        <line
                            className="s3_5"
                            x1="162.34"
                            y1="245.83"
                            x2="206.01"
                            y2="245.83"
                        />
                        <line
                            className="s3_5"
                            x1="162.34"
                            y1="252.75"
                            x2="191.91"
                            y2="252.75"
                        />
                    </g>
                    <line
                        className="s3_5"
                        x1="150.14"
                        y1="241.98"
                        x2="150.14"
                        y2="265.7"
                    />
                    <rect
                        className="s3_22"
                        x="161.54"
                        y="259.24"
                        width="8.46"
                        height="8.46"
                    />
                    <g>
                        <circle
                            className="s3_22"
                            cx="229.05"
                            cy="262.17"
                            r="6.32"
                        />
                        <path
                            className="s3_12"
                            d="m230.59,259.9c-.77-.55-1.82-.64-2.67-.24-1.69.8-2.07,2.88-.96,4.21.1.12.21.23.33.33.32.27.51.67.51,1.09,0,.58-.35,1.1-.88,1.31-.5.21-.97.49-1.39.83,1.01.67,2.21,1.07,3.51,1.07s2.51-.39,3.51-1.07c-.42-.34-.88-.61-1.38-.82-.54-.22-.89-.74-.89-1.32,0-.42.18-.81.49-1.08,1.33-1.11,1.33-3.22-.19-4.31Z"
                        />
                    </g>
                </g>
                <g>
                    <g>
                        <rect
                            className="s3_12"
                            x="139.45"
                            y="282.5"
                            width="102.42"
                            height="37.13"
                            rx="2"
                            ry="2"
                        />
                        <line
                            className="s3_5"
                            x1="162.34"
                            y1="292.15"
                            x2="206.01"
                            y2="292.15"
                        />
                        <line
                            className="s3_5"
                            x1="162.34"
                            y1="299.06"
                            x2="191.91"
                            y2="299.06"
                        />
                    </g>
                    <line
                        className="s3_5"
                        x1="150.14"
                        y1="288.29"
                        x2="150.14"
                        y2="312.01"
                    />
                    <rect
                        className="s3_22"
                        x="161.54"
                        y="305.55"
                        width="8.46"
                        height="8.46"
                    />
                    <g>
                        <circle
                            className="s3_22"
                            cx="229.05"
                            cy="308.49"
                            r="6.32"
                        />
                        <path
                            className="s3_12"
                            d="m230.59,306.21c-.77-.55-1.82-.64-2.67-.24-1.69.8-2.07,2.88-.96,4.21.1.12.21.23.33.33.32.27.51.67.51,1.09,0,.58-.35,1.1-.88,1.31-.5.21-.97.49-1.39.83,1.01.67,2.21,1.07,3.51,1.07s2.51-.39,3.51-1.07c-.42-.34-.88-.61-1.38-.82-.54-.22-.89-.74-.89-1.32,0-.42.18-.81.49-1.08,1.33-1.11,1.33-3.22-.19-4.31Z"
                        />
                    </g>
                </g>
                <g>
                    <g>
                        <rect
                            className="s3_12"
                            x="139.45"
                            y="328.81"
                            width="102.42"
                            height="37.13"
                            rx="2"
                            ry="2"
                        />
                        <line
                            className="s3_5"
                            x1="162.34"
                            y1="338.46"
                            x2="206.01"
                            y2="338.46"
                        />
                        <line
                            className="s3_5"
                            x1="162.34"
                            y1="345.38"
                            x2="191.91"
                            y2="345.38"
                        />
                    </g>
                    <line
                        className="s3_5"
                        x1="150.14"
                        y1="334.61"
                        x2="150.14"
                        y2="358.33"
                    />
                    <rect
                        className="s3_22"
                        x="161.54"
                        y="351.24"
                        width="8.46"
                        height="8.46"
                    />
                    <g>
                        <circle
                            className="s3_22"
                            cx="229.05"
                            cy="354.8"
                            r="6.32"
                        />
                        <path
                            className="s3_12"
                            d="m230.59,352.53c-.77-.55-1.82-.64-2.67-.24-1.69.8-2.07,2.88-.96,4.21.1.12.21.23.33.33.32.27.51.67.51,1.09,0,.58-.35,1.1-.88,1.31-.5.21-.97.49-1.39.83,1.01.67,2.21,1.07,3.51,1.07s2.51-.39,3.51-1.07c-.42-.34-.88-.61-1.38-.82-.54-.22-.89-.74-.89-1.32,0-.42.18-.81.49-1.08,1.33-1.11,1.33-3.22-.19-4.31Z"
                        />
                    </g>
                </g>
                <rect
                    className="s3_23"
                    x="264.11"
                    y="208.54"
                    width="131.21"
                    height="137.93"
                    rx="2"
                    ry="2"
                />
                <path
                    className="s3_6"
                    d="m555.01,207.21c-33.11-28.93-76.44-46.45-123.87-46.45-1.25,0-2.5.01-3.74.04-58.38,1.14-112.31,31.55-144.76,80.1l-.73,1.09"
                />
                <path
                    className="s3_43"
                    d="m538.7,226.11c0,34.06,27.61,61.67,61.67,61.67,34.06,0,61.67-27.61,61.67-61.67,0-34.06-27.61-61.67-61.67-61.67-34.06,0-61.67,27.61-61.67,61.67Zm92.57,0c0,17.06-13.83,30.9-30.9,30.9-17.06,0-30.9-13.83-30.9-30.9,0-17.06,13.83-30.9,30.9-30.9,17.06,0,30.9,13.83,30.9,30.9Z"
                />
                <path
                    className="s3_21"
                    d="m598.66,256.95c-16.27-.89-29.19-14.36-29.19-30.85s12.92-29.96,29.19-30.85v-30.78c-33.27.91-59.96,28.14-59.96,61.63s26.7,60.72,59.96,61.63v-30.78Z"
                />
                <path
                    className="s3_23"
                    d="m600.37,195.21c17.06,0,30.9,13.83,30.9,30.9h30.77c0-34.06-27.61-61.67-61.67-61.67-.57,0-1.14.03-1.71.04v30.78c.57-.03,1.13-.05,1.71-.05Z"
                />
                <g>
                    <g>
                        <g className="s3_41">
                            <rect
                                className="s3_12"
                                x="277.6"
                                y="236.18"
                                width="102.42"
                                height="37.13"
                                rx="2"
                                ry="2"
                            />
                        </g>
                        <line
                            className="s3_2"
                            x1="300.49"
                            y1="245.83"
                            x2="344.16"
                            y2="245.83"
                        />
                        <line
                            className="s3_2"
                            x1="300.49"
                            y1="252.75"
                            x2="330.06"
                            y2="252.75"
                        />
                    </g>
                    <line
                        className="s3_2"
                        x1="288.29"
                        y1="241.98"
                        x2="288.29"
                        y2="265.7"
                    />
                    <rect
                        className="s3_23"
                        x="299.68"
                        y="259.41"
                        width="8.46"
                        height="8.46"
                    />
                    <g>
                        <circle
                            className="s3_23"
                            cx="367.19"
                            cy="262.17"
                            r="6.32"
                        />
                        <path
                            className="s3_12"
                            d="m368.74,259.9c-.77-.55-1.82-.64-2.67-.24-1.69.8-2.07,2.88-.96,4.21.1.12.21.23.33.33.32.27.51.67.51,1.09,0,.58-.35,1.1-.88,1.31-.5.21-.97.49-1.39.83,1.01.67,2.21,1.07,3.51,1.07s2.51-.39,3.51-1.07c-.42-.34-.88-.61-1.38-.82-.54-.22-.89-.74-.89-1.32,0-.42.18-.81.49-1.08,1.33-1.11,1.33-3.22-.19-4.31Z"
                        />
                    </g>
                </g>
                <g>
                    <g>
                        <rect
                            className="s3_12"
                            x="277.6"
                            y="283.6"
                            width="102.42"
                            height="37.13"
                            rx="2"
                            ry="2"
                        />
                        <line
                            className="s3_4"
                            x1="300.49"
                            y1="293.25"
                            x2="344.16"
                            y2="293.25"
                        />
                        <line
                            className="s3_4"
                            x1="300.49"
                            y1="300.17"
                            x2="330.06"
                            y2="300.17"
                        />
                    </g>
                    <line
                        className="s3_4"
                        x1="288.29"
                        y1="289.4"
                        x2="288.29"
                        y2="313.12"
                    />
                    <rect
                        className="s3_24"
                        x="299.68"
                        y="306.83"
                        width="8.46"
                        height="8.46"
                    />
                    <g>
                        <circle
                            className="s3_24"
                            cx="367.19"
                            cy="309.59"
                            r="6.32"
                        />
                        <path
                            className="s3_12"
                            d="m368.74,307.32c-.77-.55-1.82-.64-2.67-.24-1.69.8-2.07,2.88-.96,4.21.1.12.21.23.33.33.32.27.51.67.51,1.09,0,.58-.35,1.1-.88,1.31-.5.21-.97.49-1.39.83,1.01.67,2.21,1.07,3.51,1.07s2.51-.39,3.51-1.07c-.42-.34-.88-.61-1.38-.82-.54-.22-.89-.74-.89-1.32,0-.42.18-.81.49-1.08,1.33-1.11,1.33-3.22-.19-4.31Z"
                        />
                    </g>
                </g>
                <polygon
                    className="s3_39"
                    points="255.19 402.79 256.55 407.18 249.2 407.18 247.9 402.79 255.19 402.79"
                />
                <g>
                    <rect
                        className="s3_17"
                        x="334.04"
                        y="85.06"
                        width="60"
                        height="60"
                        transform="translate(728.08 230.11) rotate(-180)"
                    />
                    <path
                        className="s3_7"
                        d="m377.93,141.75c-.01-.31-.02-.62-.04-.92-2.58,2.16-5.94,3.86-10.17,3.99-4.15.12-7.91-.99-10.78-2.96,0,0,0,0,0,0,.13,1.01.25,2.09.37,3.2h20.77c-.05-1.16-.1-2.28-.15-3.3Z"
                    />
                    <g>
                        <path
                            className="s3_15"
                            d="m357.3,145.06c-.12-1.11-.24-2.18-.37-3.2-.76-6.09-1.56-10.39-2.02-12.65,0-.01,0-.02,0-.04-.04-.2-.08-.37-.11-.54,0-.02,0-.04-.01-.06-.04-.17-.07-.32-.1-.46,0-.01,0-.02,0-.03-.01-.05-.02-.09-.03-.14,0-.04-.02-.08-.03-.12,0,0,0-.01,0-.02,0-.01,0-.02,0-.03-.06-.26-.09-.39-.09-.39h0c-2.42,1.38-4.56,2.71-6.47,4.02-1.52,1.04-2.88,2.07-4.11,3.08-3.33.55-7.01,2.5-9.89,5.03v5.54h23.26Z"
                        />
                        <path
                            className="s3_15"
                            d="m393.98,145.06s.04-.05.06-.07v-3.93c-2.18-2.02-5.02-3.93-7.95-5.41-.77-.39-1.54-.74-2.31-1.06-.13-.09-.28-.17-.41-.26-1.33-.79-3.42-1.65-4.67-2.03-.63-.19-1.04-.26-1.04-.15.01,1.49.08,5.93.41,12.91h15.9Z"
                        />
                    </g>
                    <g>
                        <path
                            className="s3_19"
                            d="m383.78,134.58c-.13-.08-.26-.17-.41-.26.14.09.28.17.41.26Z"
                        />
                        <path
                            className="s3_20"
                            d="m354.78,128.58c-.04-.17-.07-.32-.1-.46.03.13.06.29.1.46Z"
                        />
                        <path
                            className="s3_20"
                            d="m356.93,141.86s0,0,0,0c-.76-6.1-1.56-10.4-2.03-12.65.47,2.25,1.27,6.56,2.02,12.65Z"
                        />
                        <path
                            className="s3_20"
                            d="m354.9,129.17c-.04-.19-.08-.37-.11-.54.04.16.07.34.11.54Z"
                        />
                        <path
                            className="s3_19"
                            d="m372.07,127.69c-.41,0-.85-.01-1.3-.04-3.17-.23-7.17-1.39-10.89-4.52-.37-.31-1.01-.93-1.24-1.36-.23-.44-.46-.98-.68-1.58-.05,0-.1-.02-.15-.03v4.76h-.43v.99l-2.77,1.89s0,.01,0,.02c0,.04.02.08.03.12.01.04.02.09.03.14,0,.01,0,.02,0,.03.03.13.06.29.1.46,0,.02,0,.04.01.06.04.16.07.34.11.54,0,.01,0,.02,0,.04.47,2.25,1.27,6.55,2.03,12.65,2.87,1.97,6.63,3.08,10.78,2.96,4.24-.12,7.59-1.83,10.17-3.99-.17-4.57-.21-7.52-.22-8.69l-3.82-3.03-1.78-1.42Z"
                        />
                        <path
                            className="s3_10"
                            d="m372.07,127.69c-.41,0-.85-.01-1.3-.04-3.17-.23-7.17-1.39-10.89-4.52-.37-.31-1.01-.93-1.24-1.36-.23-.44-.46-.98-.68-1.58-.05,0-.1-.02-.15-.03v4.76h-.43v.99l-2.77,1.89s0,.01,0,.02c0,.04.02.08.03.12.01.04.02.09.03.14,0,.01,0,.02,0,.03.03.13.06.29.1.46,0,.02,0,.04.01.06.04.16.07.34.11.54,0,.01,0,.02,0,.04.47,2.25,1.27,6.55,2.03,12.65,2.87,1.97,6.63,3.08,10.78,2.96,4.24-.12,7.59-1.83,10.17-3.99-.17-4.57-.21-7.52-.22-8.69l-3.82-3.03-1.78-1.42Z"
                        />
                        <path
                            className="s3_7"
                            d="m354.51,127.38s.03.13.09.39c0,.01,0,.02,0,.03l2.77-1.89v-.99h-.86v-5.47c-.25-.17-.43-.43-.49-.74-.99-1.52-1.48-3.81-1.42-5.11.04-.78.13-1.33.32-1.72.3-.64.82-.86,1.69-.99.86-.13,1.78.94,2.42,2.25,2.23-1.86,3.25-5.35,3.25-5.35,4.5-11.57,13.35-5.82,13.35-5.82h0c1.68,2.04,3.58,5.45,3.32,10.32,0,0,2.06,2.48.66,5.44,0,0-2.94,8.76-3.14,8.95-.48.47-1.98.93-4.05.99-.12,0-.23,0-.35,0l1.78,1.42,3.82,3.03s0,0,0,0c0-.12.41-.05,1.04.15,1.25.38,3.33,1.24,4.67,2.03.15.09.28.17.41.26.77.32,1.54.68,2.31,1.06.19-.34.34-.69.29-1.02-.11-.68-1.38-1.21-1.51-1.94-.12-.71.89-1.64.76-2.35-.13-.74-1.41-1.25-1.54-1.93-.15-.79.85-1.73.73-2.36-.24-1.24-1.52-1.76-1.54-1.81-.07-.2.27-1.53-.68-2.54-.01-.01-.03-.02-.04-.03-.15-.33-.34-.69-.41-1.17-.09-.62.94-1.53.82-2.31-.11-.68-1.38-1.21-1.51-1.94-.13-.71.89-1.64.76-2.35-.14-.74-1.41-1.25-1.54-1.93-.05-.25.03-.52.14-.79.17-.24.31-.54.42-.87.09-.2.15-.38.16-.55.28-1.11.34-2.34.19-2.7-.29-.69-1.65-.91-1.92-1.55-.32-.74.45-1.88.2-2.46-.5-1.16-1.87-1.38-1.9-1.43-.11-.18.11-1.79-1.85-2.83-.66-.35-1.76.29-2.14.08-.72-.38-.82-1.87-1.58-2.32-.29-.17-2-.51-3.09-.23-.16-.1-.34-.25-.52-.4-.43-.37-.93-.78-1.58-.86-.64-.08-1.51.61-2.02.85-.31.15-1.14-.26-1.37-.25-.21,0-.54-.12-.85-.24-.53-.2-.53.46-1.18.59-.63.13-1.67-.32-2.07.06-.25.24-.5.49-.72.57-.2.08-.55.06-.88.04-.56-.03-1.2-.06-1.78.27-.55.31-.84.87-1.1,1.35-.16.31-.33.63-.52.77-.16.13-.5.22-.82.3-.55.14-1.17.3-1.62.78-.51.54-.67,1.28-.82,1.93-.09.43-.18.84-.35,1.14-.15.27-.44.54-.76.83-.49.45-1.03.95-1.29,1.67-.23.64-.15,1.3-.07,1.94.06.47.11.91.03,1.26-.07.32-.31.67-.56,1.05-.34.52-.74,1.1-.84,1.8-.1.66.1,1.31.27,1.89.14.45.27.88.24,1.24-.03.34-.23.74-.44,1.16-.27.54-.57,1.15-.59,1.82-.02.67.24,1.3.46,1.85.18.44.35.85.35,1.19,0,.36-.17.78-.34,1.22-.22.55-.47,1.17-.44,1.82.03.68.33,1.29.6,1.83.21.42.4.81.43,1.14.03.38-.12.82-.28,1.29-.19.57-.39,1.16-.33,1.79.05.52.25.98.47,1.41,1.9-1.31,4.05-2.64,6.47-4.02h0Z"
                        />
                        <path
                            className="s3_10"
                            d="m357.15,117.37c.63,0,1.14.51,1.14,1.14,0,.38-.19.72-.48.93v.73c.05.01.1.02.15.03.22.6.45,1.14.68,1.58.22.42.87,1.04,1.24,1.36,3.72,3.13,7.73,4.29,10.89,4.52.45.03.89.05,1.3.04.12,0,.24,0,.35,0,2.06-.06,3.56-.53,4.05-.99.2-.19,3.14-8.95,3.14-8.95,1.41-2.95-.66-5.44-.66-5.44.27-4.87-1.63-8.29-3.32-10.32h0s-8.86-5.75-13.35,5.82c0,0-1.02,3.48-3.25,5.35-.64-1.32-1.56-2.39-2.42-2.25-.87.13-1.39.35-1.69.99-.18.39-.28.94-.32,1.72-.06,1.3.43,3.59,1.42,5.11-.01-.07-.02-.13-.02-.2,0-.63.51-1.14,1.14-1.14Z"
                        />
                        <path
                            className="s3_17"
                            d="m357.81,120.17v-.73c.29-.21.48-.54.48-.93,0-.63-.51-1.14-1.14-1.14s-1.14.51-1.14,1.14c0,.07,0,.14.02.2.06.31.23.57.49.74v5.47h1.3v-4.76Z"
                        />
                    </g>
                </g>
                <g>
                    <g>
                        <rect
                            className="s3_11"
                            x="690.02"
                            y="385.56"
                            width="60"
                            height="60"
                        />
                        <path
                            className="s3_14"
                            d="m730.51,432.59l-10.4,11.18-10.01-11.33-.31-.35s-11.73,3.36-14.86,9.42l-.9,4.05h52.06l-.62-2.8c-3.12-6.06-14.71-10.44-14.71-10.44l-.26.28Z"
                        />
                    </g>
                    <g>
                        <path
                            className="s3_16"
                            d="m723.6,429.73c-1.92,1.12-4.35,1.09-6.23-.1-1.88-1.18-4.35-3.71-4.85-4.82-.13-.28-.24-.68-.35-1.15.04.57.07,1.21.1,1.88-.02,2.69-.19,5.66-.83,6.16l-1.34.73,10.01,11.33,10.39-11.18-1.61-.88c-.62-.48-.8-3.27-.82-5.88-.99,1.23-2.94,3-4.48,3.9Z"
                        />
                        <path
                            className="s3_16"
                            d="m710.99,414.77l-1.1-2.27s0-.03-.01-.04c-.13-.08-.24-.11-.33-.04-.46.4.54,2.99.4,3.29-.15.3-.93,3.21,1.71,4.67-.14-1.14-.26-2.29-.37-3.2-.1-.8-.2-1.61-.3-2.41Z"
                        />
                        <path
                            className="s3_16"
                            d="m730.72,414.78c-.15.88-.3,1.77-.43,2.64-.15.98-.35,2.25-.59,3.48,2.41-1.33,1.87-4.1,1.75-4.39-.13-.32.72-3.05.29-3.48,0,0-.02,0-.03-.01-.08.34-.18.65-.3.91l-.69.85Z"
                        />
                        <path
                            className="s3_16"
                            d="m712.52,424.81c.5,1.11,2.97,3.63,4.85,4.82,1.88,1.18,4.31,1.22,6.23.1,1.54-.9,3.49-2.67,4.48-3.9.24-.3.43-.57.53-.79.38-.79.76-2.44,1.09-4.14.23-1.23.44-2.5.59-3.48.13-.88.28-1.76.43-2.64l-.88,1.07s-.17-2.19.49-4.23c0,0-2.4-.89-2.05-2.56.36-1.67-.62-5.55-3.74-4.45-2.84,1-3.19,1.03-6.74-.19-.91-.31-1.9.17-2.22,1.07-.47,1.32-1.35,3.03-2.89,3.66l-1.46.42c-.12.77-.24,1.32-.24,1.32.51,2.08.18,4.25.18,4.25l-.19-.38c.1.8.2,1.61.3,2.41.11.91.23,2.06.37,3.2.15,1.19.32,2.38.52,3.29.11.46.22.86.35,1.15Z"
                        />
                        <path
                            className="s3_14"
                            d="m710.99,414.77l.19.38s.33-2.17-.18-4.25c0,0,.12-.55.24-1.32l1.46-.42c1.54-.63,2.43-2.34,2.89-3.66.32-.91,1.31-1.39,2.22-1.07,3.55,1.22,3.91,1.2,6.74.19,3.12-1.11,4.09,2.78,3.74,4.45-.36,1.67,2.05,2.56,2.05,2.56-.66,2.03-.49,4.23-.49,4.23l.88-1.07.69-.85c.12-.27.22-.58.3-.91.51-2.08.31-5.28-.01-7.72-.66-5.07-5.03-8.85-10.14-8.75-1.78.04-3.03.31-3.03.31-6.58-.19-8.58,4.6-9.12,8.48-.39,2-.48,4.52.46,7.13,0,.01,0,.03.01.04l1.1,2.27Z"
                        />
                    </g>
                </g>
                <g>
                    <g className="s3_40">
                        <path
                            className="s3_27"
                            d="m413.1,115.24c0,.11.05.21.11.3.06.09.14.17.24.22.1.05.2.08.31.08.07,0,.14-.02.21-.04h0c1.22-.18,2.87-.89,4.15-2.2,1.53.63,3.25.99,5.07.99,6.36,0,11.54-4.32,11.54-9.63,0-5.31-5.18-9.63-11.54-9.63s-11.54,4.32-11.54,9.63c0,2.26.95,4.34,2.52,5.99l-.05-.03c1.02,1.1-.98,3.99-.98,3.99h0c-.04.1-.06.21-.05.32Z"
                        />
                    </g>
                    <ellipse
                        className="s3_13"
                        cx="423.2"
                        cy="104.96"
                        rx="8.98"
                        ry="7.06"
                    />
                    <path
                        className="s3_25"
                        d="m418.22,102.06h9.23c.64,0,1.15.52,1.15,1.15,0,.64-.52,1.15-1.15,1.15h-9.23c-.64,0-1.15-.52-1.15-1.15,0-.64.52-1.15,1.15-1.15Z"
                    />
                    <path
                        className="s3_26"
                        d="m418.22,106.25h3.46c.64,0,1.15.52,1.15,1.15,0,.64-.52,1.15-1.15,1.15h-3.46c-.64,0-1.15-.52-1.15-1.15,0-.64.52-1.15,1.15-1.15Z"
                    />
                </g>
            </g>
        </g>
    </svg>
);
